
<header>
  <div class="d-flex">
    <fieldmagic-dialog-title
      icon="wrench"
      class="text-primary"
      label="{{ 'asset_types' | translate }}"
    ></fieldmagic-dialog-title>
    <div class="ml-auto d-flex">
      <ul class="list-inline pull-right">
        <li class="list-inline-item">
          <button (click)="addRecord()" class="btn ml-1 btn-primary" [disabled]="bSubmitted">
            <fa-icon *ngIf="!bSubmitted" [icon]="['fas', 'plus']"></fa-icon>
            <fa-icon *ngIf="bSubmitted" [icon]="['fas', 'spinner']" [spin]="true" aria-hidden="true"></fa-icon>
            <span class="pl-1">{{ 'add' | translate }}</span>
          </button>
        </li>
        <li class="list-inline-item">
          <fieldmagic-primary-button
            (click)="closeDialog()"
            icon="times"
            variant="error"
            label="close"
            [disabled]="bSubmitted"
          ></fieldmagic-primary-button>
        </li>
      </ul>
    </div>
  </div>
</header>

<hr class="separator"/>

<mat-dialog-content>
  <div class="row">
    <div class="col-6">
      <span class="label">{{ 'site' | translate }}</span>
      <ng-select
        ngDefaultControl
        [(ngModel)]="objSite.value"
        (open)="objSite.loadDataOnClick()"
        [items]="objSite.source | async"
        [loading]="objSite.loader"
        [typeahead]="objSite.typehead"
        [ngModelOptions]="{standalone: true}"
        bindLabel="text"
        appendTo="body"
      ></ng-select>
    </div>
    <div class="col-6">
      <span class="label">{{ 'next_job_date' | translate }}</span>
      <div class="input-group">
        <input
          [(ngModel)]="objNextJobDate"
          [owlDateTime]="objFieldNextJobDate"
          [required]="true"
          [readonly]="true"
          type="text"
          class="form-control date-input"
        />
        <button class="calendar-button date-input" type="button" [owlDateTimeTrigger]="objFieldNextJobDate">
          <fa-icon [icon]="['fal', 'calendar']" style="color:#fff;" ></fa-icon>
        </button>
      </div>
      <div><owl-date-time #objFieldNextJobDate pickerType="calendar"></owl-date-time></div>
    </div>
  </div>
  <hr />
  <div class="row">
    <div class="col-12">
      <div class="asset-type-search">
        <input
          [(ngModel)]="strSearchTerm"
          (ngModelChange)="onChangeSearch($event)"
          type="text"
          class="font-size-11 form-control mb-2"
          placeholder="{{ 'search' | translate }}"
        >
        <div *ngIf="strSearchTerm" class="input-group-append">
          <fa-icon class="asset-type-search-clear" [icon]="['fas', 'times']" (click)="onClearSearch()"></fa-icon>
        </div>
    </div>
      <div class="row">
        <div class="col-6">
          <input
            type="checkbox"
            class="ml-2"
            [checked]="selectAllAssetType"
            (change)="onChangeCheckboxAll($event)"
            matTooltip="{{ 'Click to select/unselect all' | translate }}"
            matTooltipPosition="right"
          />
        </div>
        <div class="col-6">
          <fc-common-pagination [objPagination]="objPagination" (objNavigate)="onChangePage($event)"></fc-common-pagination>
        </div>
      </div>
      <table class="table table-borderless child-table w-100" style="margin-bottom: 0px;">
        <ng-container *ngIf="!listingService.bLoading; else assetTypeLoading">
          <ng-container *ngIf="arData.length; else noAssetType">
            <ng-container *ngFor="let rowData of arData; let recordIndex = index">
              <tr class="datarow" [id]="'recordDetails' + recordIndex">
                <td class="w-5">
                  <ng-container *ngIf="rowData['has_valid_group']; else invalidGroup">
                    <input
                      type="checkbox"
                      [checked]="rowData['is_checked']"
                      (change)="onChangeCheckbox($event, rowData)"
                      class="d-block position-relative asset-checkbox"
                      >
                  </ng-container>
                  <ng-template #invalidGroup>
                    <fa-icon [icon]="['far', 'exclamation-circle']" class="text-warning" matTooltip="{{ 'no_grouped_inspection' | translate }}"></fa-icon>
                  </ng-template>
                </td>
                <td class="w-25">
                  <a
                    matTooltip="{{ 'asset_type' | translate }}: {{ rowData.asset_type_text }}"
                    href="/#/admin/asset_types/{{ rowData.asset_type_id }}"
                    target="_blank"
                    class="text-primary">
                    {{ rowData.asset_type_text }}
                  </a>
                </td>
                <td class="w-75">
                  <ng-container *ngIf="rowData['is_checked'] && rowData['repeating_group']">
                    <div class="row">
                      <div class="col-4 d-flex" *ngFor="let repeatingGroup of rowData['repeating_group']; let recordIndex = index">
                        <div class="repeating-group-checkbox">
                          <input
                            type="checkbox"
                            [checked]="repeatingGroup['is_checked']"
                            (change)="onChangeCheckboxRepeatingGroup($event, rowData, repeatingGroup)"
                            class="asset-checkbox"
                          >
                        </div>
                        <span
                          class="pagination-body"
                          matTooltip="{{ 'period' | translate }}: {{ repeatingGroup.period }}">
                          {{ repeatingGroup.period | translate }}
                        </span>
                      </div>
                    </div>
                  </ng-container>
                </td>
              </tr>
            </ng-container>
          </ng-container>
        </ng-container>
        <ng-template #assetTypeLoading>
          <tr class="col-12 text-center">
            <td colspan="3" class="text-center">
              <fa-icon [icon]="['fas','spinner']" [spin]="true" aria-hidden="true"></fa-icon>
            </td>
          </tr>
        </ng-template>
        <ng-template #noAssetType>
          <tr class="col-12 text-center">
            <td colspan="3" class="text-center">
              {{ 'no_record_found' | translate }}
            </td>
          </tr>
        </ng-template>
      </table>
    </div>
  </div>
</mat-dialog-content>

